import React from 'react';
import { Box, Loader, Text, TextButton } from '@wix/design-system';
import { StepCircleHeading } from '../StepCircleHeading';
import RegenerateSparkle from './RegenerateSparkle.svg';
import { useIsMobile } from '../../hooks/useIsMobile';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { BusinessNameTiles } from './BusinessNameTiles';
import { BusinessNamesError } from './BusinessNamesError';
import { BusinessNamesHorizontalScrollGrid } from './BusinessNamesHorizontalScrollGrid';
import { useBusinessNamesSection } from './useBusinessNamesSection';
import s from './BusinessNamesSection.scss';
export const BusinessNamesSectionV2 = _ref => {
  let query = _ref.query,
    onSelectedNameChange = _ref.onSelectedNameChange,
    onUserSelectedName = _ref.onUserSelectedName,
    onNamesShown = _ref.onNamesShown;
  const isMobile = useIsMobile();
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _useBusinessNamesSect = useBusinessNamesSection({
      query,
      onSelectedNameChange,
      onUserSelectedName,
      onNamesShown
    }),
    names = _useBusinessNamesSect.names,
    selectedName = _useBusinessNamesSect.selectedName,
    isLoading = _useBusinessNamesSect.isLoading,
    isFetchingMore = _useBusinessNamesSect.isFetchingMore,
    hasError = _useBusinessNamesSect.hasError,
    ctaState = _useBusinessNamesSect.ctaState,
    retry = _useBusinessNamesSect.retry,
    namesPerBatch = _useBusinessNamesSect.namesPerBatch,
    handleSelect = _useBusinessNamesSect.handleSelect,
    handleCtaClick = _useBusinessNamesSect.handleCtaClick,
    handleTooltipView = _useBusinessNamesSect.handleTooltipView,
    ctaLabelKey = _useBusinessNamesSect.ctaLabelKey;
  const tiles = /*#__PURE__*/React.createElement(BusinessNameTiles, {
    names: names,
    isLoading: isLoading,
    isFetchingMore: isFetchingMore,
    namesPerBatch: namesPerBatch,
    selectedName: selectedName,
    onSelect: handleSelect,
    onTooltipView: handleTooltipView,
    size: "large",
    nameWeight: "normal",
    showArrowWhenSelected: !isMobile
  });
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    width: "100%",
    dataHook: "business-names-section"
  }, hasError && names.length === 0 ? /*#__PURE__*/React.createElement(BusinessNamesError, {
    onRetry: retry
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    paddingLeft: isMobile ? 'SP4' : undefined
  }, /*#__PURE__*/React.createElement(StepCircleHeading, {
    step: 1
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    tagName: "h2",
    className: s.sectionTitleV2
  }, t('domain_search_gate.bng_results.step_1.choose_name.title')))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    width: "100%"
  }, isMobile ? /*#__PURE__*/React.createElement(BusinessNamesHorizontalScrollGrid, {
    canLoadMore: ctaState === 'generateMore' && !isLoading && !isFetchingMore && names.length > 0,
    onLoadMore: handleCtaClick
  }, tiles) : /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    width: "100%"
  }, tiles), hasError ? /*#__PURE__*/React.createElement(BusinessNamesError, {
    onRetry: handleCtaClick
  }) :
  // Mobile v2 has no CTA — a scroll past the last column loads
  // the next batch instead.
  names.length > 0 && !isMobile && /*#__PURE__*/React.createElement(Box, {
    align: "left"
  }, /*#__PURE__*/React.createElement(TextButton, {
    onClick: handleCtaClick,
    disabled: isFetchingMore,
    prefixIcon: isFetchingMore ? /*#__PURE__*/React.createElement(Box, {
      width: 18,
      height: 18,
      align: "center",
      verticalAlign: "middle",
      paddingInlineEnd: "6px"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(RegenerateSparkle, {
      "aria-hidden": true
    }),
    skin: "dark",
    size: "small",
    underline: "always",
    dataHook: "business-names-cta"
  }, t(ctaLabelKey))))));
};
//# sourceMappingURL=BusinessNamesSectionV2.js.map